export const getRegionDataByCityUrl = "/api/v3/defs/region/:cityId";
export const getRegionNamesUrl = "/api/v3/defs/region/names";
export const getRegionByCoordinatesUrl = "/api/v3/defs/region/byCoordinates";
export const getRegionPopulationFactorUrl =
  "/api/v3/defs/region/:cityId/populationFactor";
export const getPincodeRankingByTgUrl =
  "/api/v3/defs/region/pincodeRankingByTg";
